import React from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { formatTransactiontDate } from "../../../../helpers/date/date";
import { getStatusColor } from "../../PerformerStatements/IncomeStatement";
import { fetchIncomeWalletHistoryStart } from "../../../../store/actions/WalletAction";

import "./styles/cards.css";
import NothingHere from "../../../../images_new/icon/nothing_here.svg?react";
import { statementStatuses } from '../../../../helpers/constants/statementStatuses';

export default function EarningCards() {
  const dispatch = useDispatch();
  const walletHistory = useSelector((state) => state.wallet.walletHistory);

  useEffect(() => {
    dispatch(fetchIncomeWalletHistoryStart());
  }, []);

  return (
    <>
      <div className={`cards-container last-card-margin`}>
        {walletHistory?.data?.history?.length ? (
          walletHistory?.data?.history?.map((wallet, index) => (
            <div
              className={`statement-card ${index % 2 !== 0 ? "bg-white" : ""}`}
            >
              <div className="statement-card-header">
                <h1
                  className="statement-card-title"
                  dangerouslySetInnerHTML={{ __html: wallet.message }}
                ></h1>
              </div>
              <div className="statement-card-body">
                <div className="w-100 d-flex justify-content-between">
                  <p className="statement-text-title">Date & time</p>{" "}
                  <p className="statement-text-data">
                    {formatTransactiontDate(wallet.paid_date)}
                  </p>
                </div>
                <div className="w-100 d-flex justify-content-between mt-1">
                  <p className="statement-text-title">Amount</p>{" "}
                  <p className="statement-text-data">
                    {" "}
                    {wallet.requested_amount_formatted}
                  </p>
                </div>
                <div className="w-100 d-flex justify-content-between mt-1">
                  <p className="statement-text-title">Fee</p>{" "}
                  <p className="statement-text-data">
                    {wallet.admin_amount_formatted}
                  </p>
                </div>
                <div className={`w-100 d-flex justify-content-between mt-1 `}>
                  <p className="statement-text-title">Net</p>{" "}
                  <p className="statement-text-data">
                    {wallet.user_amount_formatted}
                  </p>
                </div>
                <div className={`w-100 d-flex justify-content-between mt-1 `}>
                  <p className="statement-text-title">Status</p>{" "}
                  <p
                    className={`statement-text-data hidden-xs status-text status-text-${getStatusColor(
                      statementStatuses[wallet.status]
                    )}`}
                  >
                    {statementStatuses[wallet.status]}
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <>
            <div className="d-flex w-100 justify-content-center mt-3">
              <NothingHere />
            </div>
          </>
        )}
      </div>
    </>
  );
}
